/**
 * @author gyb(mocheer)
 * @email `mocheer@foxmail.com`  
 * @since 2018-3-23
 * @see https://github.com/yakitoritabetai/Leaflet.LabelTextCollision
 * @see https://github.com/XC-Zhang/leaflet-text
 * @see https://github.com/namniak/canvas-text-wrapper
 */
let {
  Layer,
  latLng: toLatLng
} = L;
let multiNewLineDelimiter = '\u200B'; //不可见字符，用于多行文本，空行文本
/** 
 * 
 */
Layer.include({
  /**
   * 
   */
  getText() {
    return this._text;
  },
  /**
   * 
   * @param {*} map 
   */
  bindText(content, options) {
    //
    if (this._text instanceof L.Text) {
      this._text.setContent(content);
    } else {
      let {
        _latlng
      } = this;
      // 绑定文本和图标，比如说危险区内部的警告图标，或者河流上的文本标注
      this._text = content ? L.text(_latlng, content, options) : new L.VectorMarker(_latlng, options);
    }
    //
    this._initTextInteractions();
    //
    if (this._map && this._map.hasLayer(this)) {
      this.openText();
    }
    return this;
  },
  /**
   * 初始化交互事件
   * @param 
   */
  _initTextInteractions(removeOrAdd) {
    if (!removeOrAdd && this._textHandlersAdded) {
      return;
    }
    let onOff = removeOrAdd ? 'off' : 'on';
    let events = {
      remove: this._closeText,
      move: this._moveText
    };
    this[onOff](events);
    this._textHandlersAdded = true;
  },
  /**
   * 
   * @param {*} layer 
   * @param {*} latlng 
   */
  openText(layer, latlng) {
    if (!(layer instanceof Layer)) {
      latlng = layer;
      layer = this;
    }
    if (!latlng) {
      latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
    }
    let {
      _map,
      _text
    } = this;
    if (_map) {
      _text._source = layer;
      _text.setLatLng(latlng);
      if (!_map.hasLayer(_text)) {
        _map.addLayer(_text);
      }
    }
  },
  /**
   * 
   * @param {*} map 
   */
  unbindText(map) {
    let {
      _text
    } = this;
    if (_text) {
      map.removeLayer(_text);
      this._text = null;
    }
  },
  /**
   * 
   */
  _closeText() {
    let {
      _map,
      _text
    } = this;
    if (_map && _text && _map.hasLayer(_text)) {
      _map.removeLayer(_text);
    }
  },
  /**
   * 
   */
  _moveText(e) {
    this._text.setLatLng(e.latlng);
  }
})
/**
 * 
 */
L.Canvas.include({
  /**
   * 获取文本宽度
   */
  _getTextWidth(font, text) {
    this._ctx.font = font;
    return this._ctx.measureText(text).width;
  },
  /**
   * 绘制文本背景框
   */
  _fillTextWrapper(layer) {
    let p = layer._point;
    let ctx = this._ctx;
    let options = layer.options;
    let {
      offset,
      textAlign,
      textBaseline,
      anchor,
      outlineColor,
      backgroundColor
    } = options;
    let width = layer._textWidth;
    let height = layer._textHeight;
    let {
      x,
      y
    } = p;
    let direction; // 这里指三角箭头的方向
    //
    if (offset) {
      p = p.subtract(offset); //使得锚点指向原始位置
      let [offsetX, offsetY] = offset;
      if (Math.abs(offsetY) > height / 2) { //isTopBotoom
        if (Math.abs(offsetX) > Math.abs(offsetY)) {
          direction = offsetX > 0 ? 'right' : 'left';
        } else {
          direction = offsetY < 0 ? 'top' : 'bottom';
        }
      } else if (Math.abs(offsetX) > width / 2) {
        if (Math.abs(offsetX) < Math.abs(offsetY)) {
          direction = offsetY > 0 ? 'bottom' : 'top';
        } else {
          direction = offsetX < 0 ? 'left' : 'right';
        }
      }
    }

    //padding
    width += 8;
    height += 8;
    //
    switch (textAlign) {
      default: //center
        x -= width / 2;
        break;
    }
    switch (textBaseline) {
      default: //middle
        y -= height / 2;
        break;
    }
    y += 2;
    //
    let r = 3; // 圆角半径
    let a = 5; // 三角边长
    let PI = Math.PI;
    ctx.beginPath();
    ctx.lineWidth = 1;
    ctx.strokeStyle = outlineColor;
    ctx.fillStyle = backgroundColor;
    //

    ctx.moveTo(x + r, y);
    switch (direction) {
      case 'top':
        // 上边框
        ctx.lineTo(x + width - r, y);
        // 右上半弧
        ctx.arc(x + width - r, y + r, r, 1.5 * PI, 2 * PI);
        // 右
        ctx.lineTo(x + width, y + height - r);
        // 右下半弧
        ctx.arc(x + width - r, y + height - r, r, 0, .5 * PI);
        // 下三角
        ctx.lineTo(x + width / 2 + a, y + height);
        anchor ? ctx.lineTo(p.x, p.y) : ctx.lineTo(x + width / 2, y + height + a);
        ctx.lineTo(x + width / 2 - a, y + height);
        ctx.lineTo(x + r, y + height);
        // 左下半弧
        ctx.arc(x + r, y + height - r, r, 0.5 * PI, PI);
        // 左
        ctx.lineTo(x, y + r);
        // 左上半弧
        ctx.arc(x + r, y + r, r, PI, 1.5 * PI);
        break
      case 'bottom':
        // 上三角
        ctx.lineTo(x + width / 2 - a, y);
        anchor ? ctx.lineTo(p.x, p.y) : ctx.lineTo(x + width / 2, y - a);
        ctx.lineTo(x + width / 2 + a, y);
        ctx.lineTo(x + width - r, y);
        // 右上半弧
        ctx.arc(x + width - r, y + r, r, 1.5 * PI, 2 * PI);
        // 右
        ctx.lineTo(x + width, y + height - r);
        // 右下半弧
        ctx.arc(x + width - r, y + height - r, r, 0, .5 * PI);
        // 下
        ctx.lineTo(x + r, y + height);
        // 左下半弧
        ctx.arc(x + r, y + height - r, r, 0.5 * PI, PI);
        // 左
        ctx.lineTo(x, y + r);
        // 左上半弧
        ctx.arc(x + r, y + r, r, PI, 1.5 * PI);
        break
      case 'left':
        // 上
        ctx.lineTo(x + width - r, y);
        // 右上半弧
        ctx.arc(x + width - r, y + r, r, 1.5 * PI, 2 * PI);
        // 右三角
        ctx.lineTo(x + width, y + height / 2 - a);
        anchor ? ctx.lineTo(p.x, p.y) : ctx.lineTo(x + width + a, y + height / 2);
        ctx.lineTo(x + width, y + height / 2 + a);
        ctx.lineTo(x + width, y + height - r);
        // 右下半弧
        ctx.arc(x + width - r, y + height - r, r, 0, .5 * PI);
        // 下
        ctx.lineTo(x + r, y + height);
        // 左下半弧
        ctx.arc(x + r, y + height - r, r, 0.5 * PI, PI);
        // 左
        ctx.lineTo(x, y + r);
        // 左上半弧
        ctx.arc(x + r, y + r, r, PI, 1.5 * PI);
        break
      case 'right':
        // 上
        ctx.lineTo(x + width - r, y);
        // 右上半弧
        ctx.arc(x + width - r, y + r, r, 1.5 * PI, 2 * PI);
        // 右
        ctx.lineTo(x + width, y + height - r);
        // 右下半弧
        ctx.arc(x + width - r, y + height - r, r, 0, .5 * PI);
        // 下
        ctx.lineTo(x + r, y + height);
        // 左下半弧
        ctx.arc(x + r, y + height - r, r, 0.5 * PI, PI);
        // 三角
        ctx.lineTo(x, y + height / 2 + a);
        anchor ? ctx.lineTo(p.x, p.y) : ctx.lineTo(x - a, y + height / 2);
        ctx.lineTo(x, y + height / 2 - a);
        //  左
        ctx.lineTo(x, y + r);
        // 左上半弧
        ctx.arc(x + r, y + r, r, PI, 1.5 * PI);
        break
      default:
        // 上
        ctx.lineTo(x + width - r, y);
        // 右上半弧
        ctx.arc(x + width - r, y + r, r, 1.5 * PI, 2 * PI);
        // 右三角
        ctx.lineTo(x + width, y + height - r);
        // 右下半弧
        ctx.arc(x + width - r, y + height - r, r, 0, .5 * PI);
        // 下
        ctx.lineTo(x + r, y + height);
        // 左下半弧
        ctx.arc(x + r, y + height - r, r, 0.5 * PI, PI);
        // 左
        ctx.lineTo(x, y + r);
        // 左上半弧
        ctx.arc(x + r, y + r, r, PI, 1.5 * PI);
        break;
    }
    //
    ctx.globalAlpha = .8;
    ctx.fill();
    ctx.globalAlpha = .95;
    ctx.stroke();
  },
  /**
   * 
   */
  _updateText(layer) {
    if (!this._drawing) { // || layer._empty()
      return;
    }

    var p = layer._point;
    var ctx = this._ctx;
    var options = layer.options;

    if (options.showBackground) {
      this._fillTextWrapper(layer);
    }
    // 
    // if("单行文本"===true){
    //   ctx.rotate(options.rotation);
    //   ctx.fillText(layer._text, 0, 0);
    //   if (options.stroke) {
    //     ctx.strokeText(layer._text, 0, 0);
    //   }
    //   ctx.rotate(-options.rotation);
    // }
    //
    // 多行文本（已包含单行文本）
    let {
      _lines,
      _lineHeight,
      _textHeight
    } = layer;
    let width = layer._textWidth;
    let skipLineOnMatch = multiNewLineDelimiter; // + ' ';
    let y = -_textHeight / 2 - _lineHeight / 2 + 3; //+3 垂直居中
    //
    switch (options.textAlign) {
      case 'left': //文字居左对齐，背景框不变
        p = p.add({
          x: -width / 2,
          y: 0
        })
        break;
      case 'right': //文字居右对齐，背景框不变
        p = p.add({
          x: width / 2,
          y: 0
        })
        break;
    }
    ctx.font = options.font;
    ctx.translate(p.x, p.y);
    ctx.fillStyle = options.color;
    ctx.textAlign = options.textAlign;
    ctx.textBaseline = options.textBaseline;
    //
    for (var i = 0; i < _lines.length; i++) {
      y += _lineHeight;
      if (_lines[i] !== skipLineOnMatch) {
        options.fill && ctx.fillText(_lines[i], 0, y);
        if (options.stroke) {
          ctx.strokeText(_lines[i], 0, y);
        }
      }
    }
    //
    ctx.translate(-p.x, -p.y);
  }
});

/**
 * 
 */
L.Text = L.Path.extend({
  /**
   * 
   */
  options: {
    color: 'blue',
    fill: true,
    fillOpacity: 1,
    rotation: 0,
    stroke: false,
    textAlign: 'center', //left right start center end
    textBaseline: 'middle', //top bottom middle hanging
    font: "14px 新宋体",
    direction: 'auto', //
    outlineColor: '#000',
    backgroundColor: '#fff', // 背景框
    // draggable:false,
    lineHeight: 1, // 行高，用于多行文本
    allowNewLine: true, // 允许\n新行，true的时候\n开启新行，false的时候\n文本保留
    lineBreak: 'auto' // 
  },
  /**
   * 
   */
  initialize: function (latlng, text, options) {
    options = L.setOptions(this, options);
    this._latlng = toLatLng(latlng);
    this._text = String(text || options.text);
    this._addDragEvents();
  },
  /**
   * 删除偏移量，防止拖动的时候计算错误
   * 标绘过程中可能刚开始没有偏移量，之后会有偏移量
   */
  _addDragEvents() {
    // 
    let {
      options
    } = this;
    //
    this.on('dragstart', e => {
      let {
        offset
      } = options;
      if (!offset) return;
      let matrix = this.dragging._matrix;
      matrix[4] -= offset[0];
      matrix[5] -= offset[1];
    }).on('drag', e => {
      let {
        offset
      } = options;
      if (!offset) return;
      let matrix = this.dragging._matrix;
      offset[0] += matrix[4];
      offset[1] += matrix[5];
      matrix[4] = 0;
      matrix[5] = 0;
      //
      this._updatePath();
      this._project();
      this._transform(null);
    }).on('dragend', e => {
      this._pxBounds = this.__pxBounds;
    })

  },
  /**
   * @override
   * @param {*} map 
   */
  beforeAdd(map) {
    this._renderer = map.getRenderer(this);
    this.wrap();
  },
  /**
   * 
   * @param {*} text 
   */
  handleMultipleNewline(text) {
    do {
      text = text.replace(/\n\n/g, '\n' + multiNewLineDelimiter + '\n');
    } while (text.indexOf('\n\n') > -1);
    return text;
  },
  /**
   * 换行
   */
  wrap() {
    let text = this.handleMultipleNewline(this._text);
    let newLineIndexes = [];
    //
    let {
      options
    } = this;
    if (options.allowNewLine) {
      let newLines = text.trim().split('\n');
      for (let i = 0, idx = 0; i < newLines.length - 1; i++) {
        idx += newLines[i].trim().length;
        newLineIndexes.push(idx)
      }
      text = newLines.join('')
    }
    //
    let words = text.trim();
    // breakText
    let lines = this._lines = [];
    for (let i = 0, j = 0; i < words.length; j++) {
      lines[j] = '';

      if (options.lineBreak === 'auto') {
        while (i < words.length) {
          lines[j] += words[i]; //+ ' ';
          i++;
          if (options.allowNewLine) { //\n 换行
            for (let k = 0; k < newLineIndexes.length; k++) {
              if (newLineIndexes[k] === i) {
                j++;
                lines[j] = '';
                break;
              }
            }
          }
        }
        lines[j] = lines[j].trim();
      } else {
        lines[j] = words[i];
        i++;
      }
    }
    //
    let fontSize = +options.font.match(/\d+(px|em|%)/g)[0].match(/\d+/g);
    let lineHeight = this._lineHeight = fontSize * options.lineHeight;
    //
    this._textHeight = this._lines.length * lineHeight;
    this._textWidth = T.max(this._lines.map(text => this._renderer._getTextWidth(options.font, text)));
    // tooltip 默认
    if ((!options.direction || options.direction === 'top') && !options.offset) {
      options.offset = [0, -this._textHeight - 5]
    }
  },
  /**
   * 
   * @param {*} text 
   */
  setContent(text) {
    this._text = String(text);
    this.wrap();
    this._update();
  },
  /**
   * 
   * @param {*} latlng 
   */
  setLatLng(latlng) {
    this._latlng = toLatLng(latlng);
    this._update();
    // 
    return this.fire('move', {
      latlng: this._latlng
    });
  },
  /**
   * 
   */
  getLatLng() {
    return this._latlng;
  },
  /**
   * 
   */
  _project() {
    let point = this.__point = this._map.latLngToLayerPoint(this._latlng);
    // 偏移
    if (this.options.offset) {
      point = point.add(this.options.offset)
    }
    //
    if (this.options.direction === 'top' || !this.options.direction) {
      point = point.add({
        x: 0,
        y: -10
      })
    }
    this._point = point;
    this._updateBounds();
  },
  /**
   * 
   */
  _updateBounds() {
    let w = this._textWidth;
    let h = this._textHeight;
    let padding = 4; // 边框+三角对话框
    var p = [w / 2 + padding, h / 2 + padding];
    let point = this._point;
    this.__pxBounds = L.bounds(point.subtract(p), point.add(p));
    this._pxBounds = this.options.anchor ? L.bounds(point.subtract(p), point.add(p)).extend(this.__point) : this.__pxBounds; // 防止三角对话框局部刷新问题
  },
  /**
   * 
   */
  _update() {
    if (this._map) {
      this._updatePath();
    }
  },
  /**
   * 
   */
  _updatePath() {
    this._renderer._updateText(this);
  },
  /**
   * 
   */
  _empty() {
    return !this._renderer._bounds.intersects(this._pxBounds);
  },
  /**
   * 支持事件
   */
  _containsPoint: function (p) {
    // return false;
    return this.__pxBounds.contains(p);
  },
  /**
   * 
   */
  toGeoJSON() {
    let {
      lat,
      lng
    } = this.getLatLng();
    this.options.text = this._text;

    return {
      type: 'Feature',
      properties: {},
      geometry: {
        coordinates: [lng, lat],
        type: 'Text'
      }
    }
  }
});

L.text = function (latlng, text, options) {
  return new L.Text(latlng, text, options);
};



// WEBPACK FOOTER //
// ./src/feature/Text.js